import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import StandardThumb from '../../../../DeviationViews/Thumb/Standard';
import MobileThumb from '../../../../DeviationViews/Thumb/Mobile';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';

import s from './DeviationMobileList.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

/** Sidebar block layout id 5 */
const DeviationMobileList: React.FC<React.PropsWithChildren<Props>> = ({
  block,
  deviation: parentDeviation,
}) => {
  const isMLT = block.contentType === 'recommended';
  const deviations = block.deviations?.slice(0, 9);

  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.DEVIATION_SIDEBAR,
    {
      cookieDim: 'width',
    }
  );

  return (
    <SidebarBlockWrapper deviation={parentDeviation} block={block}>
      <div className={s['root']}>
        <DeviationDuperbrowseContext
          streamId={`sidebar-mobilelist-${block.contentType}`}
          deviations={deviations ?? []}
          parent={{
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId,
          }}
        >
          <div ref={ref}>
            {deviations?.map(deviation =>
              isMLT ? (
                <MobileThumb
                  key={deviation.deviationId}
                  className={s['thumb']}
                  deviation={deviation}
                  width={measuredContainer.width}
                  // heads-up: this includes the controls above and below the image
                  height={400}
                />
              ) : (
                <StandardThumb
                  key={deviation.deviationId}
                  deviation={deviation}
                  width={measuredContainer.width}
                  height={239}
                  className={s['thumb']}
                />
              )
            )}
          </div>
        </DeviationDuperbrowseContext>
      </div>
    </SidebarBlockWrapper>
  );
};
DeviationMobileList.displayName = 'DeviationMobileList';

export default DeviationMobileList;
